export default function description() {
    return (
        <div className="card__description-basic">
            <div className="card__description">
                <div className="card__description-title">Загальна характеристика</div>
                <p className="card__description-text">
                    НС X 7902 — це універсальний гібрид нового покоління, який поєднує стабільну врожайність, високу якість насіння та відмінну адаптивність до різних технологій вирощування.
                </p>
                <p className="card__description-text">
                    Його ключова перевага — баланс між інтенсивністю та стабільністю, що дозволяє отримувати прогнозований результат у широкому спектрі умов.
                </p>
                <ol className="card__description-list">
                    <p className="card__description-title">
                        Продуктивність і якість
                    </p>
                    <li className="card__description-numbering">Потенціал урожайності: до 5,0 т/га</li>
                    <li className="card__description-numbering">Олійність: 53–55% (підвищений рівень)</li>
                    <li className="card__description-numbering">Стійкість до вовчка — A–G</li>
                    <p className="card__description-text">
                        Його ключова перевага — баланс між інтенсивністю та стабільністю, що дозволяє отримувати прогнозований результат у широкому спектрі умов.
                    </p>
                </ol>
                <div className="card__description-title">Морфологія та розвиток</div>
                <ol className="card__description-list">
                    <li className="card__description-numbering">Вегетаційний період: 100–105 днів</li>
                    <li className="card__description-numbering">Висота рослин: 140–170 см</li>
                    <p className="card__description-text">
                        Компактніші рослини забезпечують кращу стійкість до вилягання та зручність у збиранні.
                    </p>
                </ol>
                <div className="card__description-title">Адаптивність</div>
                <ol className="card__description-list">
                    <p className="card__description-title">
                        НС X 7902 демонструє стабільні результати у:
                    </p>
                    <li className="card__description-numbering">Степу</li>
                    <li className="card__description-numbering">Лісостепу</li>
                    <li className="card__description-numbering">Поліссі</li>
                    <p className="card__description-text">
                        Гібрид добре працює як при достатньому зволоженні, так і в умовах дефіциту вологи.
                    </p>
                </ol>
                <div className="card__description-title">Поведінка в полі</div>
                <ol className="card__description-list">
                    <li className="card__description-numbering">Енергія стартового росту — 9/10</li>
                    <li className="card__description-numbering">Посухостійкість — 7/10</li>
                    <li className="card__description-numbering">Стійкість до вилягання — 8/10</li>
                    <p className="card__description-text">
                        Гібрид швидко стартує, рівномірно розвивається і добре тримає густоту.
                    </p>
                </ol>
                <div className="card__description-title">Ключові переваги</div>
                <ol className="card__description-list">
                    <li className="card__description-numbering">Потужний стартовий ріст</li>
                    <li className="card__description-numbering">Гнучкість до густоти посіву</li>
                    <li className="card__description-numbering">Стабільність при різних рівнях вологи</li>
                    <li className="card__description-numbering">Адаптивність до мінімального обробітку ґрунту</li>
                </ol>
                <div className="card__description-title">Практичне застосування</div>
                <ol className="card__description-list">
                    <p className="card__description-title">
                        НС X 7902 — це універсальний варіант для:
                    </p>
                    <li className="card__description-numbering">господарств із різним рівнем технології</li>
                    <li className="card__description-numbering">полів із нестабільною вологістю</li>
                    <li className="card__description-numbering">систем мінімального або нульового обробітку</li>
                    <p className="card__description-text">
                        Рекомендується застосування гербіцидів системи SUMO®.
                    </p>
                </ol>
                <div className="aside__title">Агрохімічні характеристики</div>
                <div className="aside__content">
                    <div className="aside-char--basic">
                        <div className="aside-char__head">Енергiя початкового росту</div>
                        <div className="aside-char__char">
                            <div className="aside-char__items aside-char__items--9">
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                            <div className="aside-char__count">9</div>
                        </div>
                    </div>
                    <div className="aside-char--basic">
                        <div className="aside-char__head">Посухостiйкiсть</div>
                        <div className="aside-char__char">
                            <div className="aside-char__items aside-char__items--7">
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                            <div className="aside-char__count">7</div>
                        </div>
                    </div>
                    <div className="aside-char--basic">
                        <div className="aside-char__head">Стiйкiсть до вилягання</div>
                        <div className="aside-char__char">
                            <div className="aside-char__items aside-char__items--9">
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                            <div className="aside-char__count">9</div>
                        </div>
                    </div>
                </div>
                <p className="card__description-text">
                    НС X 7902 — це гібрид для тих, хто шукає збалансоване рішення без ризиків. Ідеальний варіант “на всі поля”, де важлива стабільність і прогнозованість.
                </p>
            </div>
            <div className="card__description-preference">
                <div className="aside__title--new">Головні переваги</div>
                <div className="asede__head">
                    <div className="aside__block">Потужний стартовий ріст — впевнено тримає темп із перших днів</div>
                    <div className="aside__block">Гнучкий до густоти, стабільний за різних рівнів вологи</div>
                    <div className="aside__block">Відмінна адаптивність до посухи та мінімального обробітку ґрунту</div>
                </div>
            </div>
        </div>
    );
}
